export default Object.freeze({
  ONGOING: 'En cours',
  PAUSED: 'Pause',
  CLOSED: 'Clôturé',
  URGENT: 'Urgent',
});
